import { Anchor } from "antd";
import React from "react";
import { FormSectionModel } from "../../../models/form-section.model";
import { CheckedIcon, UncheckIcon } from "../icon";

const { Link } = Anchor;

interface Props {
    sections: FormSectionModel[];
    targetOffset?: number;
}
const AppAnchor = (props: Props) => {

    const renderAchorLinkTitle = (item: FormSectionModel) => {
        return (
            <>
                {item.is_completed ? <CheckedIcon /> : <UncheckIcon />}
                <span>{item.title}</span>
            </>
        )
    }
    return (
        <Anchor targetOffset={props.targetOffset || 200}
        offsetTop={162}>
            {
                props.sections.map((item, index) => (
                    <Link key={index} href={`#section${item.id}`} title={renderAchorLinkTitle(item)}></Link>
                ))
            }
        </Anchor>
    )
}

export default AppAnchor
